export const AIR_SPACE_COLOR_TYPE = [
    {
        id: 0,
        name: 'VTS®'
    },
    {
        id: 1,
        name: 'Airspace - Stainless black'
    },
    {
        id: 2,
        name: 'Airspace - Black'
    },
]

export const HEAT_TREATMENT = [
    {
        id: 0,
        name: 'Heat Strengthened'
    },
    {
        id: 1,
        name: 'Fully Tempered'
    },
    {
        id: 2,
        name: 'Fully Tempered, 100% Heat Soaked'
    },
    {
        id: 3,
        name: 'Annealed'
    },
]

export const SIGHTLINE = [
    {
        id: 0,
        name: '1/2" sightline'
    },
    {
        id: 1,
        name: '5/8" sightline'
    },
    {
        id: 2,
        name: '3/4" sightline'
    },
    {
        id: 3,
        name: '7/8" sightline'
    },
    {
        id: 4,
        name: '1" sightline'
    },
    {
        id: 5,
        name: '1 1/8” sightline'
    },
    {
        id: 6,
        name: '1 1/4" sightline'
    },
]